import React from "react";
import { Helmet } from "react-helmet";

const HtmlAttributes = React.memo(({ iso639_1LanguageCode }) => {
  return <Helmet htmlAttributes={{ lang: iso639_1LanguageCode }}></Helmet>;
});

export default HtmlAttributes;
